import { GlLoadingIcon } from '@gitlab/ui';
import { n__, s__ } from '~/locale';
import ReviewerDropdown from '~/merge_requests/components/reviewers/reviewer_dropdown.vue';
export default {
    name: 'ReviewerTitleEE',
    components: {
        GlLoadingIcon,
        ReviewerDropdown
    },
    props: {
        loading: {
            type: Boolean,
            required: false,
            default: false
        },
        numberOfReviewers: {
            type: Number,
            required: true
        },
        editable: {
            type: Boolean,
            required: true
        },
        reviewers: {
            type: Array,
            required: false,
            default: ()=>[]
        }
    },
    computed: {
        reviewerTitle () {
            const reviewers = this.numberOfReviewers;
            return n__('Reviewer', `%d Reviewers`, reviewers);
        }
    },
    i18n: {
        changeReviewer: s__('MergeRequest|Change reviewer')
    }
};
